"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavBarEventsHelper = void 0;
const events_1 = require("@front/event/events");
const component_1 = require("@front/layouts/default-layout/component");
const NavBarSignalHelper_1 = require("./NavBarSignalHelper");
class NavBarEventsHelper {
    static setEvents() {
        component_1.DefaultLayout.get().on(events_1.appEvents.login, (event) => {
            this.currentUser = component_1.DefaultLayout.USER;
        });
        this.on(events_1.appEvents.logout, () => {
            this.currentUser = component_1.DefaultLayout.USER;
        });
        this.on(events_1.appEvents.notify, (event) => {
            this.$emit(events_1.appEvents.notify, event.detail);
        });
        // Handle model selection directly through NavBarSignalHelper
        this.on('model:selected', (event) => {
            NavBarSignalHelper_1.NavBarSignalHelper.onSelect.call(this, event.detail);
        });
        this.on(events_1.appEvents.frontChatConversationEnd, (event) => {
            this.conversationSignal.setValue({ conversation: null, frontMessages: [], isNew: false });
        });
    }
    static cleanupEvents() {
        // Events are automatically cleaned up by RWS framework
        console.log('NavBar: Events cleaned up');
    }
}
exports.NavBarEventsHelper = NavBarEventsHelper;
